module.exports = __webpack_public_path__ + "img/car.55172236.gif";